import React, { useContext } from "react";
import { Spinner, SpinnerSize } from "@nuorder/components";
import cx from "classnames";

import { DATATEST } from "./constants";
import { ThemeContextNuO } from "../nuorder-theme";
import { TSizes, TVariants } from "../types";
import { useStyles } from "./loading-indicator.styles";

type TLoadingIndicatorProps = {
    size?: Extract<TSizes, "default" | "large" | "small">;
    variant?: Extract<TVariants, "default" | "primary" | "action" | "subtle" | "action">;
    className?: string;
};

export const LoadingIndicator = ({ variant = "default", ...props }: TLoadingIndicatorProps) => {
    const themeContextNuO = useContext(ThemeContextNuO);
    const styles = useStyles(themeContextNuO);
    const size = props.size === "default" ? "medium" : props.size;

    return (
        <Spinner
            size={SpinnerSize[size]}
            className={cx(styles[`${variant}Loading`], props.className)}
            data-test={DATATEST.ROOT}
        />
    );
};
